import React from "react";
import { Grid, Typography } from "@mui/material";
import DetailRow from "../../pages/common-features/DetailRow";
import { formatDateToShortMonth } from "../../utils/dateFormatUtils";

interface ProvideCourseDetailsTabProps {
  partnerDetails: any[];
  isMobile: boolean;
}

const ProvideCourseDetailsTab: React.FC<ProvideCourseDetailsTabProps> = ({
  partnerDetails,
  isMobile,
}) => {
  if (!partnerDetails || partnerDetails.length === 0)
    return (
      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary">
          No details available.
        </Typography>
      </Grid>
    );
  const capitalizeValue = (val: any) => {
    if (val === null || val === undefined) return "";

    return String(val)
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <>
      {partnerDetails?.map((field: any, subIndex: number) => {
        const skipNames = [
          "applicationid",
          "salesmanagername",
          "salesmanageremail",
          "salesmanagermobile",
          "status",
          "appliedloanamount",
          "totalcost",
          "product",
          "createdon",
        ];
        if (skipNames.includes((field.name || "").toLowerCase())) return null;

        // Format createdOn date if present
        const displayValue =
          field.name === "createdOn" && field.value
            ? formatDateToShortMonth(field.value)
            : capitalizeValue(field.value);

        return (
          <Grid item xs={12} sm={6} md={3} key={subIndex}>
            <DetailRow
              item={{
                label: field.label,
                value: displayValue,
                isVerified: false,
              }}
            />
          </Grid>
        );
      })}
    </>
  );
};

export default ProvideCourseDetailsTab;
